const PAGE_SPECIFIC_PARAMS = ['collapsible-'];

export const getSharedQueryParams = (search: string): string => {
    const params = new URLSearchParams(search);

    const sharedParams = new URLSearchParams();
    params.forEach((value, key) => {
        const match = PAGE_SPECIFIC_PARAMS.some((p) => key.startsWith(p));
        if (!match) {
            sharedParams.set(key, value);
        }
    });

    return sharedParams.toString();
};
